import baseTheme from '../common/base-theme';
import type { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import { ParkerCustomizations } from '../templates-info';

const parkerTheme = (customizations: ParkerCustomizations): ResumeTheme => {
  const calcSize = getCalcSize(customizations.baseSize);
  const theme = {
    ...baseTheme,
    baseSize: customizations.baseSize,
    print: {
      ...baseTheme.print,
      backgroundColor: customizations.background,
      paddingX: calcSize(6.25, 60, 100),
      paddingY: calcSize(3.75, 45, 60),
    },
    web: {
      ...baseTheme.web,
      contentWidth: 811 + baseTheme.web.paddingX[1] * 2,
      backgroundColor: customizations.background,
    },
    space: {
      sectionHeadingMarginBottom: calcSize(1.5),
    },
    fonts: {
      body: 'Barlow, sans-serif',
      heading: 'Barlow, sans-serif',
    },
    fontSizes: [16, 20, 22, 36],
    colors: {
      text: customizations.text1,
      dates: customizations.text2,
      accent: customizations.accent1,
      background: customizations.background,
    },
    fontWeights: {
      body: 400,
      heading: 600,
      bold: 600,
    },
    lineHeights: {
      body: 1.2,
      heading: 1.2,
    },
    text: {
      // Base text styles. Inherited by everything else.
      heading: {
        fontFamily: 'heading',
        lineHeight: 'heading',
        fontWeight: 'heading',
        color: 'text',
      },
      body: {
        fontFamily: 'body',
        lineHeight: 'body',
        fontWeight: 'body',
        color: 'text',
        fontSize: 0,
      },
      // Resume text elements
      resumeHeading: {
        variant: 'text.heading',
        fontSize: 3,
        marginBottom: calcSize(0.5),
      },
      sectionHeading: {
        variant: 'text.heading',
        fontSize: 2,
        // Handled in ./SectionHeading
        // marginBottom: 24,
        color: 'accent',
      },
      sectionItemHeading: {
        variant: 'text.heading',
        fontSize: 1,
      },
      sectionItemSubHeading: {
        variant: 'text.heading',
        fontSize: 0,
      },
      paragraph: {
        variant: 'text.body',
        mb: calcSize(0.5),
      },
      listItem: {
        variant: 'text.body',
        mb: calcSize(0.5),
      },
      summaryListItem: {
        variant: 'text.listItem',
        marginLeft: 18,
        paddingLeft: 0,
      },
    },
    // Containers used to add margin bottom
    headerContainer: {
      marginBottom: calcSize(2.5),
    },
    sectionContainer: {
      marginBottom: calcSize(2.5),
    },
    detailSectionItemContainer: {
      // Handled in DetailSection component
    },
    blockListSectionItemContainer: {
      marginBottom: calcSize(0.75),
    },
    firstColumn: {
      width: ['100%', 300],
      paddingRight: [0, 16],
      flexShrink: 0,
      flexGrow: 0,
    },
    summaryList: {
      padding: 0,
    },
  };
  return theme;
};

export default parkerTheme;
